import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface TipoAccion {
  id: number;
  descripcion: string;
  estado: number;
}

@Injectable({
  providedIn: 'root'
})
export class TipoAccionService {
    private apiUrl =  `${environment.apiUrl}/api/tipo_accion`; 


  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token'); // Asegúrate de tener el token almacenado
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }

    getAll(): Observable<{ data: TipoAccion[] }> {
    return this.http.get<{ data: TipoAccion[] }>(this.apiUrl, { headers: this.getAuthHeaders() });
    }


  create(data: Partial<TipoAccion>): Observable<TipoAccion> {
    return this.http.post<TipoAccion>(this.apiUrl, data, { headers: this.getAuthHeaders() });
  }

  update(id: number, data: Partial<TipoAccion>): Observable<TipoAccion> {
    return this.http.put<TipoAccion>(`${this.apiUrl}/${id}`, data, { headers: this.getAuthHeaders() });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { headers: this.getAuthHeaders() });
  }
}